module.exports = __webpack_public_path__ + "img/noodles.7d29c4e1.png";